import { Button, FormControl, Layout, LayoutContainer, Page, useAppConfig, usePath } from "@fdoh/health-ui-react";
import { useMemo, useRef } from "react";
import CSS from 'csstype';
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { useData } from "../../../hooks";
import { DateFormat, Row } from "@fdoh/health-react";
import html2canvas from "html2canvas";
import {jsPDF} from 'jspdf';
import useClient from "../../../hooks/useInspectionClient";
import { userInfo } from "os";
import useProfile from "../../../hooks/useProfile";
import { UserSecurityInput } from "../../../components/DBProtectedRoute.types";
import { useMsal } from "@azure/msal-react";
import { Video } from "@microsoft/microsoft-graph-types";

const TrainingVideosPage = () => {

    const path = usePath();
    const config = useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const turl = `${application.baseUrl}/UserTraining/` + path.current;


  return (
    <Page.Container>
  <Page.Header preTitle="Private Provider Inspection" title="Training Videos" />
  <Page.Body>
    <Layout.Container>
      <div className="row row-dec row-cards">
        <div className="col-lg-12">
        <video id="trainingVideo" height="400" width="900" controls  controlsList="nodownload">
          <source src={turl} type="video/mp4"/>
            Your browser does not support the video tag.
</video>
            {/* <video id="trainingVideo" height="400" width="900" controlslist ="nodownload">
                                    <source id="trainingSrc" type="video/mp4" src={turl}/>
                                </video> */}
        </div>            
      </div>
    </Layout.Container>        
  </Page.Body>
</Page.Container>
) ; 
}

export default TrainingVideosPage;